<fgb-mobile-page-header [pageTitle]="'gallery.page.title'" backButtonLink="/" [showBalance]="false" [showQr]="false" />
<fgb-banner class="d-lg-block d-none" [title]="'gallery.page.title' | translate" />

<div class="mobile-container pb-5">
  <fgb-worksheet-list></fgb-worksheet-list>
</div>
